import { useMemo } from "react";
import { SelectOption } from "@hatch-digital-nl/bravilor-storybook";
import { useGetRefurbishedCountriesQuery } from "../../../common/api/refurbished";

export const useCountries = (): {
    options: SelectOption[];
    isLoading: boolean;
} => {
    const { data, isLoading, isFetching } = useGetRefurbishedCountriesQuery();

    const options = useMemo(
        () =>
            (data?.data ?? []).map((country) => ({
                id: country.id,
                label: country.name,
            })),
        [data?.data],
    );

    return {
        options,
        isLoading: isLoading || isFetching,
    };
};
